import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ProjectService } from '@/services/ProjectService';
import { AssetsConfig } from '@/services/AssetsConfig';
import ProjectHeader from '@/components/header';
import CollectionNavigation from '@/components/CollectionNavigation';
import { useCollectionData } from '@/hooks/useCollectionData';
  
const UserInspirationScreen = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [selectedStyle, setSelectedStyle] = useState(null);
  const [styles, setStyles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [projectData, setProjectData] = useState(null);
  const { data: collectionData, iscollectionLoading } = useCollectionData(projectData?.collectionId);
  
  useEffect(() => {
    async function fetchProjectAndStyles() {
      try {
        setLoading(true);
        const currentProject = await ProjectService.getProjectById(projectId);
        setProjectData(currentProject);
        
        if (currentProject) {
          setSelectedStyle(currentProject.selectedStyle || null);
          // Get business-specific styles from S3 config based on subdomain
          const availableStyles = await AssetsConfig.getKitchenStyles();
          setStyles(availableStyles);
        }
      } catch (err) {
        setError('Failed to load kitchen styles. Please try again later.');
        console.error('Error:', err);
      } finally {
        setLoading(false);
      }
    }
    fetchProjectAndStyles();
  }, [projectId]);

  const handleStyleSelection = async (styleName) => {
    setSelectedStyle(styleName);
    await ProjectService.updateProject(projectId, {selectedStyle: styleName});
    navigate(`/project/${projectId}/moodboard`);
  };

  const handleNext = () => {
    if (selectedStyle) {
      navigate(`/project/${projectId}/moodboard`);
    } else {
      handleStyleSelection('Traditional');
    }
  };

  const handleBack = () => {
    navigate(`/project/${projectId}`);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <ProjectHeader 
      showBackButton={true}
      collectionData={collectionData}
      projectName={projectData?.name}
      />
      
      <main className="pt-20 px-4 pb-24">
        {/* Render navigation only if project is part of a collection */}
        {projectData?.collectionId && (
          <CollectionNavigation 
            // collectionId={projectData.collectionId}
            collectionData={collectionData}
            isLoading={iscollectionLoading}
            currentProjectId={projectId}
          />
        )}
        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle className="text-2xl font-bold text-center">Choose Your Kitchen Style</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4 mb-6">
              {styles.map((style) => (
                <div
                  key={style.name}
                  className={`cursor-pointer border p-4 rounded-lg hover:bg-gray-50 transition-all ${
                    selectedStyle === style.name ? 'ring-2 ring-blue-500' : ''
                  }`}
                  onClick={() => handleStyleSelection(style.name)}
                >
                  <img 
                    src={style.image} 
                    alt={style.name} 
                    className="w-full h-48 object-cover mb-2 rounded" 
                  />
                  <p className="text-center font-semibold">{style.name}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </main>

      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 flex justify-between items-center shadow-lg">
        <Button variant="outline" onClick={handleBack}>
          Back to All Sections
        </Button>
        <Button onClick={handleNext}>
          Next
        </Button>
      </div>
    </div>
  );
};

export default UserInspirationScreen;